import { selectCurrentUser } from './selectCurrentUser'

export const selectCurrentUserId = state => selectCurrentUser(state).id
